import { render, staticRenderFns } from "@/applications/scrum/components/TrackerDataTable/TrackerDataTablePaginated.html?vue&type=template&id=439825d2&external"
import script from "./PropositionTable.js?vue&type=script&lang=js&external"
export * from "./PropositionTable.js?vue&type=script&lang=js&external"
import style0 from "@/applications/scrum/components/TrackerDataTable/TrackerDataTable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VSpacer,VTextField,VToolbar})
